import _ from 'lodash';

export class EmailContact {
   public name: string;
   public email: string;
   public displayText: string;

   constructor(email: string, name?: string) {
      this.name = name;
      this.email = email;
      this.displayText = !_.isEmpty(name) ? `${name} (${email})` : email;
   }

   isDuplicate(selectedEntries: EmailContact[]) {
      return selectedEntries.some((entry: EmailContact) => entry.email.toLowerCase() === this.email.toLowerCase());
   }
}
